import {GeneralTypeModel} from '../models/general-type.model';

export enum ReviewSessionOrderingTypeEnum {
  Random = 1,
  DateTimeAscending = 2
}

export function reviewSessionOrderingTypeEnumToGeneralTypeModel(type: ReviewSessionOrderingTypeEnum | null): GeneralTypeModel {
  switch (type) {
    case ReviewSessionOrderingTypeEnum.Random:
      return { name: 'Random', color: '#00a798'};
    case ReviewSessionOrderingTypeEnum.DateTimeAscending:
      return { name: 'Date time created', color: '#233e9b'};
    default:
      return { name: 'Unknown', color: '#7b7b7b'};
  }
}
